import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { publicRessourceAPI } from '../api/api';
import { ArticleRessource, EnTetePartage, PageChargement, PageLienInvalide } from '../components/RessourcePartage';

export default function RessourcePublique() {
  const { token } = useParams();
  const [ressource, setRessource] = useState(null);
  const [loading, setLoading] = useState(true);
  const [invalid, setInvalid] = useState(false);

  useEffect(() => {
    publicRessourceAPI.get(token)
      .then(data => setRessource(data))
      .catch(() => setInvalid(true))
      .finally(() => setLoading(false));
  }, [token]);

  useEffect(() => {
    if (ressource) document.title = `${ressource.nom} · AXELERANCE`;
  }, [ressource]);

  if (loading) return <PageChargement />;
  if (invalid) return <PageLienInvalide />;

  return (
    <div className="min-h-screen bg-white">
      <EnTetePartage largeur="max-w-2xl" />
      <main className="max-w-2xl mx-auto px-4 sm:px-6 py-8 sm:py-12">
        <ArticleRessource ressource={ressource} />
      </main>
    </div>
  );
}
